import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { toStorefrontMediaUrl } from '@/lib/media-url';
import type { RichSegment } from '../types';
import styles from './RichSegments.module.css';
interface RichSegmentsProps {
  segments: RichSegment[];
}

/**
 * Renders an array of inline RichSegment values. Used by Paragraph, list items,
 * Callout body, Faq answer text, and any other block that contains inline-level
 * content. Not a block kind itself — this is an internal helper.
 */
export function RichSegments(t0) {
  const $ = _c(4);
  const {
    segments
  } = t0;
  let t1;
  if ($[0] !== segments) {
    t1 = segments.map(_temp);
    $[0] = segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(segment, index) {
  return <RichSegmentNode key={index} segment={segment} index={index} />;
}
function RichSegmentNode(t0) {
  const $ = _c(23);
  const {
    segment
  } = t0;
  switch (segment.kind) {
    case "text":
      {
        let t1;
        if ($[0] !== segment.text) {
          t1 = <>{segment.text}</>;
          $[0] = segment.text;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "lineBreak":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <br />;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        const t2 = segment.spaceAfter === false ? null : " ";
        let t3;
        if ($[3] !== t2) {
          t3 = <>{t1}{t2}</>;
          $[3] = t2;
          $[4] = t3;
        } else {
          t3 = $[4];
        }
        return t3;
      }
    case "emphasis":
      {
        let t1;
        if ($[5] !== segment.text) {
          t1 = <em>{segment.text}</em>;
          $[5] = segment.text;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "strong":
      {
        let t1;
        if ($[7] !== segment.text) {
          t1 = <strong>{segment.text}</strong>;
          $[7] = segment.text;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case "link":
      {
        let t1;
        if ($[9] !== segment.href) {
          t1 = toStorefrontMediaUrl(segment.href);
          $[9] = segment.href;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        let t2;
        if ($[11] !== segment.rel || $[12] !== segment.target || $[13] !== segment.text || $[14] !== t1) {
          t2 = <a href={t1} target={segment.target} rel={segment.rel} className={styles.link}>{segment.text}</a>;
          $[11] = segment.rel;
          $[12] = segment.target;
          $[13] = segment.text;
          $[14] = t1;
          $[15] = t2;
        } else {
          t2 = $[15];
        }
        return t2;
      }
    case "coloredText":
      {
        let t1;
        if ($[16] !== segment.color) {
          t1 = {
            color: segment.color
          };
          $[16] = segment.color;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        let t2;
        if ($[18] !== segment.text || $[19] !== t1) {
          t2 = <span className={styles.coloredText} style={t1}>{segment.text}</span>;
          $[18] = segment.text;
          $[19] = t1;
          $[20] = t2;
        } else {
          t2 = $[20];
        }
        return t2;
      }
    default:
      {
        const exhaustive = segment;
        const t1 = String(exhaustive);
        let t2;
        if ($[21] !== t1) {
          t2 = <>{t1}</>;
          $[21] = t1;
          $[22] = t2;
        } else {
          t2 = $[22];
        }
        return t2;
      }
  }
}